// TODO: This file was created by bulk-decaffeinate.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

/**
 * @deprecated - New callers should use copyToClipboard instead.
 */

import Clipboard from 'clipboard';
import $ from 'jquery';
import React from 'react';
import _ from 'underscore';

import {assert} from 'Asserts';
import legacyRunModal from 'ui-library/legacyRunModal';
import * as keyboard from 'util/Keyboard';
import uniqueId from 'util/uniqueId';

function isElementFullySelected(el: HTMLInputElement | HTMLTextAreaElement): boolean {
  return el.selectionStart === 0 && el.selectionEnd === $(el).val()!.length;
}

/**
 * @deprecated Use notifyCopied from copyToClipboard instead.
 */
function notifyCopied(text: string): void {
  const notifications = require('notifications').default;
  notifications.success(text);
}

/**
 * @deprecated Use defaultNotifyCopied from copyToClipboard instead.
 */
function defaultNotifyCopied(text: string): void {
  const maxLen = 100;
  const notifications = require('notifications').default;

  if (text.length > maxLen) {
    text = `${text.substr(0, maxLen)}...`;
  }
  notifications.success(
    <>
      Copied to clipboard: <code>{text}</code>
    </>
  );
}

/**
 * Helper method that returns the target corresponding to a trigger (as specified as an id in data-target).
 * @param  {HTMLElement} triggerEl
 * @return {HTMLElement}
 * @deprecated
 */
function getTarget(triggerEl: HTMLElement): HTMLElement | undefined {
  return $(`#${$(triggerEl).data('target')}`)[0];
}

interface ClipboardProxyOptions {
  dataTransform?: (value: string) => string;
  notifyCopied?: (text: string) => void;
  click?: () => void;
  tooltipContainer?: string;
}

/**
 * A wrapper class around ClipboardJS that falls back to a (tooltip) prompt to Ctrl-C in the target input or
 * opens a modal to Ctrl-C if no input is specified (e.g. in a right click menu option).
 *
 * @deprecated Use copyToClipboard instead.
 */
class ClipboardProxy {
  clip?: Clipboard;
  trigger?: HTMLElement | null;
  dataTransform?: (value: string) => string;
  notifyCopied: (text: string) => void;
  click?: () => void;
  tooltipContainer: string;
  cid: string;
  inputs: Array<HTMLElement>;
  tooltips: Array<HTMLElement>;

  /**
   * @param  {Function} [options.dataTransform] Optional function that takes in the target HTMLElement's
   *                                            value as the sole parameter and returns the text that should
   *                                            be stored on the clipboard. Required if the `trigger`
   *                                            specified in the call to `glue` does not have a data-target.
   *
   * @param  {Function} [options.notifyCopied]  Optional success callback bound to the target HTMLElement,
   *                                            that by default shows the message "Copied to clipboard: ..."
   *
   * @param  {Function} [options.click]         Optional success callback bound to the target HTMLElement
   *
   * @param  {String}   [tooltipContainer]      Optional string specifying where a tooltip should be appended
   *                                            and defaults to 'body'. If the clipboard targets are inside a
   *                                            modal, the modal should be specified.
   */
  constructor(options?: ClipboardProxyOptions) {
    if (options == null) {
      options = {};
    }
    this.dataTransform = options.dataTransform;
    this.notifyCopied = options.notifyCopied ?? defaultNotifyCopied;
    this.click = options.click;
    this.tooltipContainer = options.tooltipContainer ?? 'body';
    this.cid = uniqueId('clipboard');
    this.inputs = [];
    this.tooltips = [];
  }

  /**
   * Helper method to find the ClipboardJS-registered trigger element given one of its descendents.
   * ClipboardJS returns that the element that triggered the event, e.g. it could be the FontAwesome
   * icon in the trigger button.
   * @param  {HTMLElement} trigger
   * @return {HTMLElement}
   */
  getCurrentTrigger(trigger: HTMLElement): HTMLElement {
    return $(trigger).closest(this.trigger)[0]!;
  }

  /**
   * Given the trigger from a ClipboardJS event, returns the text to be copied. It grabs the value of
   * the INPUT/TEXTAREA referenced by `trigger`'s data-target and then passes it through the user-option
   * `dataTransform`.
   * @param  {HTMLElement} trigger An HTMLElement that matches an element by the user specified
   *                               trigger, or one of its descendants.
   * @return {String}              The text to be copied to the clipboard
   */
  getTextToCopy(trigger: HTMLElement): string {
    const currentTrigger = this.getCurrentTrigger(trigger);
    let value = this.getTargetValue(trigger);
    if (this.dataTransform != null) {
      value = this.dataTransform.call(currentTrigger, value);
    }
    if (value == null) {
      throw new Error('Expected node to have data-target or a dataTransform method');
    }
    return value;
  }

  getTargetValue(trigger: HTMLElement): string | null | undefined {
    return $(getTarget(this.getCurrentTrigger(trigger))!).val() as string | null | undefined;
  }

  /**
   * Fires the appropriate user-registered handlers, namely `notifyCopied` and `click`. To be called on the
   * ClipboardJS success event.
   * @param  {Object} e the event object from the ClipboardJS success event.
   */
  handleSuccess(e: {trigger: HTMLElement; text: string}): void {
    const trigger = this.getCurrentTrigger(e.trigger);
    this.notifyCopied.call(trigger, e.text);
    if (this.click != null) {
      this.click.call(trigger);
    }
  }

  /**
   * Handles the ClipboardJS error event triggered in browser without execCommand('copy') support
   * (e.g. Safari 9.0), providing the user a fallback mechanism to copy.
   */
  handleError(e: {trigger: HTMLElement}): void {
    const trigger = this.getCurrentTrigger(e.trigger);
    const target = getTarget(trigger);

    // If there is no corresponding INPUT/TEXTAREA to the trigger element, display a modal.
    if (target == null) {
      const text = this.getTextToCopy(trigger);
      const CopyModalClass = require('util/clipboard/CopyTextModal').default; // Avoid circular dependency
      // similarly, replicating entire (small) props of `CopyModalClass` to avoid circular dependency
      legacyRunModal<{
        onRequestClose: () => void;
        onCopy: (e: React.ClipboardEvent<HTMLTextAreaElement>) => void;
        text: string;
      }>(CopyModalClass, {
        text,
        onCopy: (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
          if (isElementFullySelected(e.target as HTMLTextAreaElement)) {
            // After the copy event is over, trigger success handler. Modal should close itself after calling
            // this callback.
            _.defer(() => {
              this.handleSuccess({trigger, text});
            });
          }
        },
      });
      return;
    }

    // Otherwise, display a tooltip.
    // Select the target after the click event is over.
    _.defer(() => $(target).focus().select());

    // Register a tooltip if not yet registered.
    if (!Array.from(this.tooltips).includes(target)) {
      this.tooltips.push(target);
      $(target)
        // Bootstrap and jQuery UI both provide their own $.tooltip. We are using Bootstrap's, but since we
        // use both libraries, we install both @types/bootstrap and @types/jqueryui; unfortunately, this means
        // both type definitions are merged into $.tooltip, resulting in multiple overloads of `$.tooltip`.
        // Bootstrap has `tooltip(command: string): jQuery` while jQuery UI's has `tooltip('destroy'): void`.
        // To get the correct overloaded type, we cast to string.
        .tooltip('destroy' as string)
        .tooltip({
          title: `${keyboard.ctrl}-C to copy`,
          placement: 'bottom',
          container: this.tooltipContainer,
          trigger: 'manual',
          delay: 0,
        });
    }

    // Show the correct tooltip and then auto-hide after a second.
    for (const tooltip of Array.from(this.tooltips)) {
      $(tooltip).tooltip(tooltip === target ? 'show' : 'hide');
    }
    setTimeout(() => {
      $(target).tooltip('hide');
    }, 1000);
  }

  /**
   * Performs cleanup to be called before removing the triggers/targets from the DOM.
   */
  unglue(): void {
    $(document).off(`.${this.cid}`);
    $(this.inputs).off('.clipboard');
    for (const tooltip of Array.from(this.tooltips)) {
      $(tooltip).tooltip('destroy');
    }
    this.tooltips = [];
    this.inputs = [];
    this.trigger = null;
    this.clip!.destroy();
  }

  /**
   * Given a `trigger` element that id's a TEXTAREA/INPUT in its data-target attribute, attaches click/copy
   * handlers to the `trigger` element that copies the TEXTAREA's text to the clipboard.
   * @param  {HTMLElement} trigger
   */
  glue(trigger: HTMLElement): void {
    assert(this.trigger == null, 'trigger should be null before glue');
    this.trigger = trigger;

    // Registers a ClipboardJS instance for the specified `trigger`.
    this.clip = new Clipboard(this.trigger, {text: this.getTextToCopy.bind(this)})
      .on('success', this.handleSuccess.bind(this))
      .on('error', this.handleError.bind(this));

    // Register copy handlers that allow the user to copy the text inside the target via Cmd-C.
    // Also a fallback for browsers that do not support execCommand.
    $(this.trigger).each((i, trigger: HTMLElement) => {
      $(getTarget(trigger)!)
        .off('copy.clipboard')
        .on('copy.clipboard', (e) => {
          if (!isElementFullySelected(e.target as HTMLInputElement | HTMLTextAreaElement)) {
            return;
          }

          // Override normal copy behavior if there was post-processing done via `dataTransform`
          const originalText = this.getTargetValue(trigger);
          const text = this.getTextToCopy(trigger); // `originalText` with `dataTransform` applied
          if (originalText !== text) {
            e.preventDefault();
            (e.originalEvent as ClipboardEvent).clipboardData!.setData('text/plain', text);
          }

          // Allow the event to be handled after the copy event finishes if the entire text was selected.
          _.defer(() => {
            this.handleSuccess({trigger, text});
          });
        })
        .each((i, target: HTMLElement) => {
          // Register elements so we can clean up handlers on unglue.
          this.inputs.push(target);
        });
    });

    // Bootstrap's modal registers a focusin handler that gives focus back to the modal if a child does not
    // have focus, which enables close-on-Esc functionality. In Firefox, the focus seems to be immediately
    // returned, preventing ClipboardJS from creating a temporary TEXTAREA on BODY. As a workaround, we
    // stopPropagation if the modal loses focus to a readonly textarea (which realistically only happens when
    // working with ClipboardJS).
    $(document).on(`focusin.${this.cid}`, 'textarea[readonly]', (e) => {
      if ($('.modal.in').length) {
        // Detect if a modal is open
        e.stopPropagation();
      }
    });
  }
}

/**
 * A factory for ClipboardProxy that configures it given the options, glued to the specified trigger.
 * Caller is expected to call `unglue` before removing a trigger/target DOM node.
 * @param  {HTMLElement} trigger See `ClipboardProxy::glue`
 * @param  {Object} [options] See `ClipboardProxy`'s constructor
 * @return {ClipboardProxy}
 * @deprecated Use copyToClipboard instead.
 */
function glue(trigger: HTMLElement, options?: ClipboardProxyOptions): ClipboardProxy {
  if (options == null) {
    options = {};
  }
  const clip = new ClipboardProxy(options);
  clip.glue(trigger);
  return clip;
}

/**
 * Cleans up any listeners/tooltips associated with a ClipboardProxy
 * @param  {ClipboardProxy} clip
 * @deprecated Use copyToClipboard instead.
 */
function unglue(clip: ClipboardProxy): void {
  clip.unglue();
}

export {notifyCopied, defaultNotifyCopied, glue, unglue, getTarget as __getTarget, ClipboardProxy};
